export const LEGAL_EFFECTIVE_DATE = "August 10, 2026";
export const TERMS_VERSION = "2026-08-10";
export const PRIVACY_VERSION = "2026-08-10";
